import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import React from "react";
import { PageTransition } from "Animations";

export const PageWrapper = ({ children, pageTransition, bgColor }) => {
  return pageTransition ? (
    <PageTransition>
      <PageWrapperStyle bgColor={bgColor}>{children}</PageWrapperStyle>
    </PageTransition>
  ) : (
    <PageWrapperStyle>{children}</PageWrapperStyle>
  );
};
export const PageWrapperStyle = styled.div`
  background-color: ${({ bgColor }) => (bgColor ? bgColor : "#fff")};
  width: 100%;
  height: 100%;

  ${media.greaterThan(breakpoints.ipad)`
    	color: white;
  	`}
`;
